import { InternalMessageType } from '../enums';
import {
  internalAddToCartPayloadValidator,
  internalCloseDialogPayloadValidator,
  internalGalleryReadyPayloadValidator,
  internalOpenDialogPayloadValidator,
  internalPrefetchDialogPayloadValidator,
  internalResizePayloadValidator,
} from '../messages';
import {
  InternalMessagePayloadByType,
  InternalMessagePayloadValidator,
} from '../types';

const internalMessagePayloadValidators: Partial<{
  [MessageType in InternalMessageType]: InternalMessagePayloadValidator<MessageType>;
}> = {
  [InternalMessageType.AddToCart]: internalAddToCartPayloadValidator,
  [InternalMessageType.CloseDialog]: internalCloseDialogPayloadValidator,
  [InternalMessageType.GalleryReady]: internalGalleryReadyPayloadValidator,
  [InternalMessageType.OpenDialog]: internalOpenDialogPayloadValidator,
  [InternalMessageType.PrefetchDialog]: internalPrefetchDialogPayloadValidator,
  [InternalMessageType.Resize]: internalResizePayloadValidator,
};

export const isInternalMessagePayload = <
  MessageType extends InternalMessageType,
>(
  type: MessageType,
  payload: unknown
): payload is InternalMessagePayloadByType[MessageType] => {
  const validator = internalMessagePayloadValidators[type];
  if (!validator) return false;
  return validator(payload);
};
